import React from "react";
import t from "../../../helpers/t";
import Biscuit from "../../../../utils/Biscuit";

const NewTaskButtton = (props) => {
  const currentUrl = new URL(window.location.href);
  return (
    <>
      <a
        href={"/tasks/add" + currentUrl.search}
        id="inb-c-left-bar-add-resource"
        className={"button beautify beautify-" + Biscuit.get("user.client_id")}
      >
        <i className="fi fi-page-add"> </i>
        <span>{t("new_task_name")}</span>
      </a>
    </>
  );
};
export default NewTaskButtton;
